export * from './ages';
export * from './resources';
export * from './jobs';
export * from './buildings';
export * from './techs';
export * from './ancestral';
export * from './tales';

/** Tuning constants for the simulation, kept in one place for balance passes. */
export const BALANCE = {
  /** Nutrition each tribe member consumes per second before modifiers. */
  foodPerHeadPerSecond: 0.2,
  /** Population the tribe starts a generation with, before Ancestral bonuses. */
  baseStartPopulation: 3,
  /** Shelter capacity with no buildings or techs. */
  baseShelter: 5,
  /** Fraction of the population gap closed per second at full surplus. */
  baseGrowthRate: 0.02,
  /** Fraction of population lost per second while starving. */
  starvationRate: 0.03,
  /** Storage caps are multiplied by this per age advanced. */
  storagePerAge: 3,

  /** Ancestral Knowledge payout: coefficient and population exponent. */
  akCoefficient: 0.55,
  akPopulationExponent: 1.15,
  /** Extra AK multiplier per technology known at the time of the reset. */
  akPerTech: 0.05,
  /** AK payout multiplier per age reached. */
  akPerAge: 2.4,
  /** Minimum peak population before the fire may be passed. */
  minimumPeakPopulationToPrestige: 10,

  /** Vigor: seconds a stack survives without a manual gather. */
  vigorDecaySeconds: 12,
  vigorBaseStacks: 25,
  vigorBasePerStack: 0.02,
  /** A manual gather yields this many seconds of current production. */
  manualGatherSeconds: 3,
  /** Manual gathers below this production floor still give a flat amount. */
  manualGatherFloor: 2,

  /** Seconds between tale rolls, randomised within these bounds. */
  taleIntervalMinSeconds: 100,
  taleIntervalMaxSeconds: 260,
  /** Most recent tales retained in the log. */
  taleLogLimit: 60,

  /** Offline accumulation cap in hours, before Ancestral bonuses. */
  baseOfflineHours: 12,
  /** Coarse step size used when simulating offline time. */
  offlineStepSeconds: 30,
  /** Hard cap on offline simulation steps, protecting very long absences. */
  offlineMaxSteps: 6000,
} as const;
